import PropTypes from 'prop-types';
import { ButtonBase } from '@mui/material';
import PushPinIcon from '@mui/icons-material/PushPin';

const PinButton = ({
	label,
	active = false,
	disabled = false,
	title,
	onClick,
	'data-testid': dataTestId = 'pin-button',
}) => (
	<ButtonBase
		onClick={onClick}
		disabled={disabled}
		disableRipple
		title={title}
		data-testid={dataTestId}
		sx={{
			display: 'flex',
			alignItems: 'center',
			gap: '4px',
			flexShrink: 0,
			fontSize: '11px',
			fontWeight: 500,
			color: active ? 'status.blue.text' : 'text.secondary',
			backgroundColor: active ? 'status.blue.bg' : 'transparent',
			border: '0.5px solid',
			borderColor: active ? 'primary.main' : 'border.main',
			borderRadius: '6px',
			padding: '4px 9px',
			'&:hover': {
				backgroundColor: 'background.subtle',
				color: 'text.primary',
			},
			'&.Mui-disabled': { opacity: 0.5 },
		}}
	>
		<PushPinIcon
			sx={{ width: 12, height: 12, flexShrink: 0 }}
			fontSize='inherit'
		/>
		{label}
	</ButtonBase>
);

PinButton.propTypes = {
	label: PropTypes.string.isRequired,
	active: PropTypes.bool,
	disabled: PropTypes.bool,
	title: PropTypes.string,
	onClick: PropTypes.func,
	'data-testid': PropTypes.string,
};

export default PinButton;
